import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useAuth } from '@/contexts/auth-context';
import { getProfileInitials, getRoleDisplayName } from '@/lib/profile';
import { supabase } from '@/integrations/supabase/client';

interface UserMenuDropdownProps {
  className?: string;
}

export const UserMenuDropdown: React.FC<UserMenuDropdownProps> = ({ className }) => {
  const navigate = useNavigate();
  const { profile } = useAuth();

  const displayName = profile
    ? `${profile.first_name} ${profile.last_name}`
    : 'Swiss Finance Team';
  const roleDisplayName = getRoleDisplayName(profile?.role);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className={`flex items-center gap-3.5 hover:opacity-80 transition-opacity cursor-pointer ${className}`}>
          <div className="text-right">
            <p className="text-brand-primary text-base font-medium leading-5">
              {displayName}
            </p>
            <p className="text-xs text-brand-text-secondary">
              {roleDisplayName}
            </p>
          </div>
          <Avatar className="w-[38px] h-[38px]">
            {(profile as any)?.avatar_url ? (
              <AvatarImage 
                src={(profile as any).avatar_url} 
                alt={displayName}
                className="object-cover"
              />
            ) : null}
            <AvatarFallback className="bg-brand-primary text-brand-primary-foreground">
              {getProfileInitials(profile)}
            </AvatarFallback>
          </Avatar>
          <i className="fa-solid fa-chevron-down text-muted-foreground text-sm"></i>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">{displayName}</p>
            <p className="text-xs leading-none text-muted-foreground">
              {profile?.email}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate('/settings')}>
          <i className="fa-solid fa-gear mr-2 text-sm"></i>
          <span>Settings & Profile</span>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <i className="fa-solid fa-circle-question mr-2 text-sm"></i>
          <span>Help & Support</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleSignOut} className="text-red-600">
          <i className="fa-solid fa-right-from-bracket mr-2 text-sm"></i>
          <span>Sign out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};








